const WEEKDAY_TO_SALES_DAY = {
  0: 7,
  1: 1,
  2: 2,
  3: 3,
  4: 4,
  5: 5,
  6: 6,
};

const SALES_DAY_LABELS = {
  1: "Pon",
  2: "Wt",
  3: "śr",
  4: "Czw",
  5: "Pt",
  6: "Sob",
  7: "Nd",
};

export const normalizeSalesDays = (value) => {
  if (!value && value !== 0) {
    return [];
  }
  if (Array.isArray(value)) {
    return value
      .map((day) => Number(day))
      .filter((day) => Number.isInteger(day) && day >= 1 && day <= 7);
  }
  if (typeof value === "string") {
    return value
      .split("")
      .map((char) => Number(char))
      .filter((day) => Number.isInteger(day) && day >= 1 && day <= 7);
  }
  if (typeof value === "number") {
    return value
      .toString()
      .split("")
      .map((char) => Number(char))
      .filter((day) => Number.isInteger(day) && day >= 1 && day <= 7);
  }
  return [];
};

export const formatSalesDaysLabel = (value) => {
  const normalized = normalizeSalesDays(value);
  if (normalized.length === 0 || normalized.length === 7) {
    return "Dostępne codziennie";
  }
  return `Dostępne: ${normalized
    .map((day) => SALES_DAY_LABELS[day] || day)
    .join(", ")}`;
};

export const getSalesDayFromDate = (value) => {
  if (!value) {
    return null;
  }
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return null;
  }
  return WEEKDAY_TO_SALES_DAY[date.getDay()] ?? null;
};

export const isProductAvailableOnDay = (product, salesDay) => {
  if (!product) {
    return false;
  }
  if (product.isActive === false) {
    return false;
  }
  if (!salesDay) {
    return true;
  }
  const salesDays = normalizeSalesDays(product.salesDays);
  if (salesDays.length === 0) {
    return true;
  }
  return salesDays.includes(salesDay);
};
